import { FeatureMapItem } from '../types';

// The list of the order in which summary display features should be shown.
// Also maps where feature set items should be combined or split for display purposes
// To make TS happy we still have to map standalone features to an empty array
const SummaryFeatureMap: FeatureMapItem[] = [
  {
    featureItemKey: 'create_limit',
    features: ['survey_create_limit', 'create_question_limit'],
  },
  {
    featureItemKey: 'response_count',
    features: ['base_response_count', 'num_free_responses', 'unlimited_responses'],
  },
  {
    featureItemKey: 'support',
    features: ['email_support', 'priority_email_support', 'phone_support'],
  },
  {
    featureItemKey: 'quizzes_pro',
  },
  {
    featureItemKey: 'analyze_export_enabled',
  },
  {
    featureItemKey: 'analyze_export_spss_enabled',
  },
  {
    featureItemKey: 'all_data_exports',
    features: ['analyze_export_enabled', 'analyze_export_spss_enabled', 'download_as_csv_xls_pdf', 'download_as_ppt'],
  },
  {
    featureItemKey: 'skip_logic',
    features: ['create_skip_logic_enabled', 'create_piping_enabled', 'funneling_enabled'],
  },
  {
    featureItemKey: 'statistical_significance',
    features: ['statistical_significance', 'show_sig_diffs_enabled'],
  },
  {
    featureItemKey: 'survey_branding',
    features: ['create_logo_enabled', 'create_custom_theme_enabled', 'collector_friendly_url_enabled'],
  },
  {
    featureItemKey: 'create_advanced_features',
    features: ['create_quotas_enabled', 'a_b_testing', 'create_randomization_enabled'],
  },
  {
    featureItemKey: 'create_custom_variables_enabled',
  },
  {
    featureItemKey: 'payment_qt',
  },
  {
    featureItemKey: 'file_upload',
  },
  {
    featureItemKey: 'benchmark_logic',
    features: ['plans_benchmarks', 'analyze_access_benchmarking', 'benchmarks'],
  },
  {
    featureItemKey: 'click_map_qt',
  },
  {
    featureItemKey: 'collaborate',
    features: ['collaboration', 'build_surveys_together', 'share_with_your_organization'],
  },
  {
    featureItemKey: 'analyze_can_export_hide_branding',
  },
  {
    featureItemKey: 'analyze_combine_filters',
  },
  {
    featureItemKey: 'analyze_response_limit',
  },
  {
    featureItemKey: 'sentiment',
    features: ['analyze_sentiment_enabled', 'sa_en_ga'],
  },
  {
    featureItemKey: 'analyze_trends_enabled',
  },
  {
    featureItemKey: 'shared_assets',
    features: [
      'asset_library',
      'group_templates',
      'lite_library',
      'shared_library',
      'shared_group_library',
      'team_themes',
      'custom_templates',
    ],
  },
  {
    featureItemKey: 'collector_completion_url_enabled',
  },
  {
    featureItemKey: 'collector_popup_enabled',
  },
  {
    featureItemKey: 'collector_white_label_enabled',
  },
  {
    featureItemKey: 'footer_branding',
    features: ['create_toggle_footer_enabled', 'disable_footer_branding_enabled', 'hide_export_branding_enabled'],
  },
  {
    featureItemKey: 'hipaa_enabled',
  },
  {
    featureItemKey: 'multilingual',
  },
  {
    featureItemKey: 'multiple_block_rotation_enabled',
  },
  {
    featureItemKey: 'private_apps',
  },
  {
    featureItemKey: 'response_quality_enabled',
  },
  {
    featureItemKey: 'crosstabs',
    features: ['show_create_crosstab', 'filter_crosstab'],
  },
  {
    featureItemKey: 'gather_comments',
  },
  {
    featureItemKey: 'team_logic',
    features: ['team_ownership', 'user_management', 'add_users'],
  },
  {
    featureItemKey: 'advanced_logic',
  },
  {
    featureItemKey: 'admin_dashboard',
  },
  {
    featureItemKey: 'single_sign_on',
  },
  {
    featureItemKey: 'analyze_results_together',
  },
  {
    featureItemKey: 'response_alerts',
  },
  {
    featureItemKey: 'contributor_seats',
  },
  {
    featureItemKey: 'analyze_integrations',
  },
  {
    featureItemKey: 'advanced_analyze_features',
  },
  {
    featureItemKey: 'block_randomization',
  },
  {
    featureItemKey: 'flexible_plan_types',
  },
  {
    featureItemKey: 'integrations',
  },
  {
    featureItemKey: 'account_control',
  },
  {
    featureItemKey: 'enhanced_governance',
  },
  {
    featureItemKey: 'team_activity',
  },
  {
    featureItemKey: 'customer_success',
  },
  {
    featureItemKey: 'unlimited_questions',
  },
  {
    featureItemKey: 'analyze_can_share_customize_branding',
  },
  {
    featureItemKey: 'extended_piping',
  },
];

export default SummaryFeatureMap;
